const slugify = require("slugify")

const groupBy = function (xs, key) {
  return xs.reduce(function (rv, x) {
    ;(rv[x[key]] = rv[x[key]] || []).push(x)
    return rv
  }, {})
}

const toString = (...ids) => ids.filter((id) => (id || "").length > 0).join(":")

const flattenObject = (obj, parentKey = "", result = {}) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const newKey = parentKey ? `${parentKey}_${key}` : key

      if (Array.isArray(obj[key])) {
        obj[key].forEach((value, index) => {
          if (typeof value === "object" && value !== null) {
            flattenObject(value, `${newKey}_${index + 1}`, result)
          } else {
            result[`${newKey}_${index + 1}`] = value
          }
        })
      } else if (typeof obj[key] === "object" && obj[key] !== null) {
        flattenObject(obj[key], newKey, result)
      } else {
        result[newKey] = obj[key]
      }
    }
  }
  return result
}

const slugifyName = (name = "") => {
  return slugify(name, {
    lower: true,
    remove: /[*+~.,()'"!:@]/g,
  }).replace("flexday-suite-", "flexday-suites-")
}

const getRequestDate = () => {
  const now = new Date()
  const options = {
    timeZone: "America/Toronto",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }
  const formatter = new Intl.DateTimeFormat("en-CA", options)

  return formatter
    .formatToParts(now)
    .map((p) => p.value)
    .join("")
    .replaceAll("-", "/")
}

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

module.exports = {
  flattenObject,
  getRequestDate,
  groupBy,
  sleep,
  slugifyName,
  toString,
}
